// Hockey India League 2026 fixtures and results. `home`/`away` must match keys in TEAM_LOGOS.
// `score` is regulation goals; `shootout` is set when a drawn match went to a shoot-out.
export const SEASON_TITLE = 'Hockey India League 2026';

export const fixtures = [
  {
    matchNo: 1,
    stage: 'League',
    date: 'Saturday, 3 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'Accord Tamil Nadu Dragons',
    away: 'Hyderabad Toofans',
    score: '3-3',
    shootout: '4-2',
  },
  {
    matchNo: 2,
    stage: 'League',
    date: 'Sunday, 4 January 2026',
    time: '17:00 IST',
    venue: 'Chennai',
    home: 'JSW Soorma Hockey Club',
    away: 'Shrachi Bengal Tigers',
    score: '1-3',
    shootout: null,
  },
  {
    matchNo: 3,
    stage: 'League',
    date: 'Sunday, 4 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'Vedanta Kalinga Lancers',
    away: 'Ranchi Royals',
    score: '4-2',
    shootout: null,
  },
  {
    matchNo: 4,
    stage: 'League',
    date: 'Monday, 5 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'SG Pipers',
    away: 'HIL GC',
    score: '2-3',
    shootout: null,
  },
  {
    matchNo: 5,
    stage: 'League',
    date: 'Tuesday, 6 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'Accord Tamil Nadu Dragons',
    away: 'JSW Soorma Hockey Club',
    score: '3-2',
    shootout: null,
  },
  {
    matchNo: 6,
    stage: 'League',
    date: 'Wednesday, 7 January 2026',
    time: '17:00 IST',
    venue: 'Chennai',
    home: 'HIL GC',
    away: 'Shrachi Bengal Tigers',
    score: '6-3',
    shootout: null,
  },
  {
    matchNo: 7,
    stage: 'League',
    date: 'Wednesday, 7 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'Hyderabad Toofans',
    away: 'Ranchi Royals',
    score: '3-2',
    shootout: null,
  },
  {
    matchNo: 8,
    stage: 'League',
    date: 'Thursday, 8 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'Shrachi Bengal Tigers',
    away: 'Vedanta Kalinga Lancers',
    score: '1-2',
    shootout: null,
  },
  {
    matchNo: 9,
    stage: 'League',
    date: 'Friday, 9 January 2026',
    time: '17:00 IST',
    venue: 'Chennai',
    home: 'Hyderabad Toofans',
    away: 'JSW Soorma Hockey Club',
    score: '1-1',
    shootout: '1-3',
  },
  {
    matchNo: 10,
    stage: 'League',
    date: 'Friday, 9 January 2026',
    time: '19:30 IST',
    venue: 'Chennai',
    home: 'Accord Tamil Nadu Dragons',
    away: 'SG Pipers',
    score: '4-4',
    shootout: '5-4',
  },
  {
    matchNo: 11,
    stage: 'League',
    date: 'Sunday, 11 January 2026',
    time: '17:00 IST',
    venue: 'Ranchi',
    home: 'HIL GC',
    away: 'Vedanta Kalinga Lancers',
    score: '1-1',
    shootout: '1-3',
  },
  {
    matchNo: 12,
    stage: 'League',
    date: 'Sunday, 11 January 2026',
    time: '19:30 IST',
    venue: 'Ranchi',
    home: 'Ranchi Royals',
    away: 'Shrachi Bengal Tigers',
    score: '4-1',
    shootout: null,
  },
  {
    matchNo: 13,
    stage: 'League',
    date: 'Monday, 12 January 2026',
    time: '17:00 IST',
    venue: 'Ranchi',
    home: 'SG Pipers',
    away: 'Hyderabad Toofans',
    score: '2-1',
    shootout: null,
  },
  {
    matchNo: 14,
    stage: 'League',
    date: 'Monday, 12 January 2026',
    time: '19:30 IST',
    venue: 'Ranchi',
    home: 'HIL GC',
    away: 'Accord Tamil Nadu Dragons',
    score: '4-2',
    shootout: null,
  },
  {
    matchNo: 15,
    stage: 'League',
    date: 'Tuesday, 13 January 2026',
    time: '19:30 IST',
    venue: 'Ranchi',
    home: 'Shrachi Bengal Tigers',
    away: 'Accord Tamil Nadu Dragons',
    score: '5-3',
    shootout: null,
  },
  {
    matchNo: 16,
    stage: 'League',
    date: 'Wednesday, 14 January 2026',
    time: '17:00 IST',
    venue: 'Ranchi',
    home: 'Hyderabad Toofans',
    away: 'Vedanta Kalinga Lancers',
    score: '0-1',
    shootout: null,
  },
  {
    matchNo: 17,
    stage: 'League',
    date: 'Wednesday, 14 January 2026',
    time: '19:30 IST',
    venue: 'Ranchi',
    home: 'Ranchi Royals',
    away: 'SG Pipers',
    score: '6-2',
    shootout: null,
  },
  {
    matchNo: 18,
    stage: 'League',
    date: 'Thursday, 15 January 2026',
    time: '19:30 IST',
    venue: 'Ranchi',
    home: 'JSW Soorma Hockey Club',
    away: 'HIL GC',
    score: '3-1',
    shootout: null,
  },
  {
    matchNo: 19,
    stage: 'League',
    date: 'Friday, 16 January 2026',
    time: '19:30 IST',
    venue: 'Ranchi',
    home: 'Ranchi Royals',
    away: 'JSW Soorma Hockey Club',
    score: '4-1',
    shootout: null,
  },
  {
    matchNo: 20,
    stage: 'League',
    date: 'Saturday, 17 January 2026',
    time: '17:00 IST',
    venue: 'Bhubaneswar',
    home: 'Shrachi Bengal Tigers',
    away: 'Hyderabad Toofans',
    score: '0-6',
    shootout: null,
  },
  {
    matchNo: 21,
    stage: 'League',
    date: 'Saturday, 17 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Vedanta Kalinga Lancers',
    away: 'SG Pipers',
    score: '6-1',
    shootout: null,
  },
  {
    matchNo: 22,
    stage: 'League',
    date: 'Sunday, 18 January 2026',
    time: '17:00 IST',
    venue: 'Bhubaneswar',
    home: 'SG Pipers',
    away: 'Shrachi Bengal Tigers',
    score: '2-3',
    shootout: null,
  },
  {
    matchNo: 23,
    stage: 'League',
    date: 'Sunday, 18 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Vedanta Kalinga Lancers',
    away: 'Accord Tamil Nadu Dragons',
    score: '1-1',
    shootout: '4-1',
  },
  {
    matchNo: 24,
    stage: 'League',
    date: 'Monday, 19 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'HIL GC',
    away: 'Ranchi Royals',
    score: '4-4',
    shootout: '1-4',
  },
  {
    matchNo: 25,
    stage: 'League',
    date: 'Tuesday, 20 January 2026',
    time: '17:00 IST',
    venue: 'Bhubaneswar',
    home: 'Hyderabad Toofans',
    away: 'HIL GC',
    score: '3-2',
    shootout: null,
  },
  {
    matchNo: 26,
    stage: 'League',
    date: 'Tuesday, 20 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Vedanta Kalinga Lancers',
    away: 'JSW Soorma Hockey Club',
    score: '1-2',
    shootout: null,
  },
  {
    matchNo: 27,
    stage: 'League',
    date: 'Wednesday, 21 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Accord Tamil Nadu Dragons',
    away: 'Ranchi Royals',
    score: '3-3',
    shootout: '4-2',
  },
  {
    matchNo: 28,
    stage: 'League',
    date: 'Thursday, 22 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'JSW Soorma Hockey Club',
    away: 'SG Pipers',
    score: '6-1',
    shootout: null,
  },
  {
    matchNo: 29,
    stage: 'Qualifier 1',
    date: 'Friday, 23 January 2026',
    time: '17:00 IST',
    venue: 'Bhubaneswar',
    home: 'Hyderabad Toofans',
    away: 'HIL GC',
    score: '2-0',
    shootout: null,
  },
  {
    matchNo: 30,
    stage: 'Eliminator',
    date: 'Friday, 23 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Vedanta Kalinga Lancers',
    away: 'Ranchi Royals',
    score: '2-1',
    shootout: null,
  },
  {
    matchNo: 31,
    stage: 'Qualifier 2',
    date: 'Sunday, 25 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Ranchi Royals',
    away: 'Hyderabad Toofans',
    score: '3-2',
    shootout: null,
  },
  {
    matchNo: 32,
    stage: '3rd / 4th Place',
    date: 'Monday, 26 January 2026',
    time: '17:00 IST',
    venue: 'Bhubaneswar',
    home: 'HIL GC',
    away: 'Hyderabad Toofans',
    score: '3-4',
    shootout: null,
  },
  {
    matchNo: 33,
    stage: 'Final',
    date: 'Monday, 26 January 2026',
    time: '19:30 IST',
    venue: 'Bhubaneswar',
    home: 'Vedanta Kalinga Lancers',
    away: 'Ranchi Royals',
    score: '3-2',
    shootout: null,
  },
];
